import React from 'react';
import { motion } from 'framer-motion';
import { FaHistory, FaGem, FaHandshake } from 'react-icons/fa';

const AboutPage = () => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }} className="min-h-screen bg-deepDark pt-20 pb-32">
      <div className="max-w-4xl mx-auto px-4">
        
        <div className="text-center mb-24">
          <p className="text-gold text-[10px] tracking-widest uppercase mb-4">Our Heritage</p>
          <h1 className="text-5xl md:text-6xl font-serif text-white tracking-wide mb-8">LuxeJewels</h1>
          <div className="w-16 h-[1px] bg-gold mx-auto"></div>
        </div>

        <div className="prose prose-invert prose-lg mx-auto font-light leading-relaxed text-textMuted mb-24">
          <p className="first-letter:text-5xl first-letter:font-serif first-letter:text-gold first-letter:mr-3 first-letter:float-left">
            Founded on the principles of immaculate craftsmanship and timeless elegance, LuxeJewels represents the pinnacle of haute joaillerie. For generations, we have sourced the most exquisite stones from across the globe, transforming them into wearable masterpieces that transcend mere adornment to become cherished heirlooms.
          </p>
          <p>
            Our master artisans combine centuries-old goldsmithing techniques with avant-garde design philosophies, ensuring that each piece not only meets the highest standards of quality but also tells a unique story of beauty, power, and refined taste.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 border-t border-white/10 pt-24 text-center">
          <div className="flex flex-col items-center group">
            <div className="w-16 h-16 rounded-full border border-gold/30 flex items-center justify-center mb-6 text-gold group-hover:bg-gold group-hover:text-deepDark transition-colors">
              <FaHistory size={24} />
            </div>
            <h3 className="text-white font-serif tracking-widest uppercase mb-4">Legacy</h3>
            <p className="text-xs text-textMuted font-light leading-relaxed">A lineage of meticulous craftsmanship echoing through decades of mastery.</p>
          </div>
          
          <div className="flex flex-col items-center group">
            <div className="w-16 h-16 rounded-full border border-gold/30 flex items-center justify-center mb-6 text-gold group-hover:bg-gold group-hover:text-deepDark transition-colors">
              <FaGem size={24} />
            </div>
            <h3 className="text-white font-serif tracking-widest uppercase mb-4">Rarity</h3>
            <p className="text-xs text-textMuted font-light leading-relaxed">Only the top 1% of diamonds and gemstones are selected for our vaults.</p>
          </div>

          <div className="flex flex-col items-center group">
            <div className="w-16 h-16 rounded-full border border-gold/30 flex items-center justify-center mb-6 text-gold group-hover:bg-gold group-hover:text-deepDark transition-colors">
              <FaHandshake size={24} />
            </div>
            <h3 className="text-white font-serif tracking-widest uppercase mb-4">Integrity</h3>
            <p className="text-xs text-textMuted font-light leading-relaxed">Commitment to ethically sourced materials and transparent provenance.</p>
          </div>
        </div>

      </div>
    </motion.div>
  );
};

export default AboutPage;
